<template>
  <div id="create">
    <v-container fluid id="anpr-listing-view" class="px-2">
      <v-data-table
        :mobile-breakpoint="mobilebreakpoint"
        :headers="headers"
        :items="itemsWithSno"
        :items-per-page="-1"
        :search="search"
        class="elevation-4 mt-2"
        :loading="tableLoading"
        loading-text="Loading... Please wait"
      >
        <template v-slot:item.ipR_CHQ_DT="{ item }">
          <span>{{ formatDate(item.ipR_CHQ_DT, "DD-MMM-YY") }}</span>
        </template>
        <template v-slot:item.amT_BEFORE_TAX="{ item }">
          <span>{{ formatNumber(item.amT_BEFORE_TAX.toFixed(2)) }}</span>
        </template>
        <template v-slot:item.insT_TX_AMT="{ item }">
          <span>{{ formatNumber(item.insT_TX_AMT.toFixed(2)) }}</span>
        </template>
        <template v-slot:item.insT_TOT_AMT="{ item }">
          <span>{{ formatNumber(item.insT_TOT_AMT.toFixed(2)) }}</span>
        </template>

        <template slot="body.append">
          <td colspan="6" class="py-3 font-weight-black total">
            <span>Total</span>
          </td>
          <td class="py-3 font-weight-black total">
            {{ formatNumber(sumTotal("amT_BEFORE_TAX").toFixed(2)) }}
          </td>
          <td class="py-3 font-weight-black total">
            {{ formatNumber(sumTotal("insT_TX_AMT").toFixed(2)) }}
          </td>
          <td class="py-3 font-weight-black total">
            {{ formatNumber(sumTotal("insT_TOT_AMT").toFixed(2)) }}
          </td>
                 
        </template>
      </v-data-table>

      <vconfirm
        :confirmOption="confirmBox"
        @isConfirm="isConfirm"
        :dialogConfirm="dialogConfirm"
        :confirmLoading="confirmLoading"
      >
      </vconfirm>
    </v-container>
  </div>
</template>
<style scoped>
.v-data-table {
  max-width: 100%;
}
.total {
  background-color: lightgray;
  text-align: right;
  padding-right: 1em;
}

.subtotal {
  background-color: yellow;
}
</style>
<script>
import axios from "axios";
import { get } from "vuex-pathify";

import vconfirm from "@/components/v-confirm";
import { formatDate, formatNumber } from "../util/helpers";

import { showSnackbar } from "../util/globalActions";

export default {
  name: "PaymentDetailsView",
  components: { vconfirm },

  data: () => ({
    tab: null,
    validEdit: false,
    switchmobilebreakpoint: false,
    mobilebreakpoint: "200",
    confirmBox: {
      message: "",
      okCaption: "OK",
      cancelCaption: "Cancel",
      data: "",
    },
    dialogConfirm: false,
    confirmLoading: false,
    isConfirm: false,
    width: 700,
    tableLoading: false,
    loadingprofessor: false,
    valid: false,
    modal: false,
    fromDate: null,
    toDate: null,
    search: "",
    listingData: [],
    message: "",
    professors: [],
    snackbar: false,
    reqRules: [(v) => !!v || "Field is required"],
    professor_id: null,
    headers: [],
  }),
  created() {
    this.headers = [];
    this.showData();
  },
  mounted() {},
  computed: {
    apiUrl: get("app/apiUrl"),
    userid: get("user/id"),
    menuid: get("user/menuid"),
    selecteduserid: get("app/selecteduserid"),
    itemsWithSno() {
      return this.listingData.map((d, index) => ({ ...d, sno: index + 1 }))
    }
  },
  watch: {
    switchmobilebreakpoint: function(value) {
      if (value === true) this.mobilebreakpoint = "600";
      else this.mobilebreakpoint = "200";
    },
  },
  methods: {
    formatNumber,

    formatDate,

    showData() {
      const self = this;
      self.headers = [];
      self.headers.push({
        text: "SrNo",
        value:"sno",
        width: "50px",
      });
      self.headers.push({
        text: "Date",
        value: "ipR_CHQ_DT",
        width: "100px",
      });
      self.headers.push({
        text: "Installment ID",
        value: "ipR_INST_ID",
        width: "100px",
      });
      self.headers.push({
        text: "Course",
        value: "crS_SHORT_NAME",
        width: "200px",
        
      });      
      self.headers.push({
        text: "Payment Mode",
        value: "paY_MODE",
        width: "100px",
      });
      self.headers.push({
        text: "Reference No",
        value: "ipR_CHQ_NO",
        width: "100px",
      });
      self.headers.push({
        text: "Amount before tax",
        value: "amT_BEFORE_TAX",
        width: "100px",
        align: "right",
        
      });
      self.headers.push({
        text: "Tax",
        value: "insT_TX_AMT",
        width: "100px",
        align: "right",
        
      });
      self.headers.push({
        text: "Total Amount",
        value: "insT_TOT_AMT",
        width: "100px",
        align: "right",
        
      });
      
      self.tableLoading = true;

      axios({
        url: self.apiUrl + "api/Fees/PaymentDetails",
        method: "GET",
        responseType: "json",
      })
        .then(function(res) {
          self.listingData = res.data;
          console.log(self.listingData);

          self.tableLoading = false;
        })
        .catch(function(err) {
          self.tableLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },

    row_classes(item) {
      return item.rowcolor.toLowerCase();
    },

    sumTotal(key) {
      // sum data in give key (property)
      const subjectgroup = this.listingData;
      return subjectgroup.reduce((a, b) => a + (b[key] || 0), 0);
    },
  },
};
</script>
